import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import GuardianRoute from '../../shared/GuardianRoute';
import RetencionesMasivasFiles from './files/RetencionesMasivasFiles';
import RetencionesMasivasTickets from './tickets/RetencionesMasivasTickets';
import RetencionesMasivasFilesUpload from './files/upload/RetencionesMasivasFilesUpload';
import RetencionesMasivasTicketsInfo from './tickets/info/RetencionesMasivasTicketsInfo';

const RetencionesMasivasRoute = () => {
  return (
    <Switch>
      <Redirect
        from="/modulos/retenciones-masivas"
        to="/modulos/retenciones-masivas/files"
        exact
      />
      <GuardianRoute
        path="/modulos/retenciones-masivas/files"
        component={RetencionesMasivasFiles}
        can="retencion.masiva.listar.archivos"
        exact
      />
      <GuardianRoute
        path="/modulos/retenciones-masivas/files/upload"
        component={RetencionesMasivasFilesUpload}
        can="retencion.masiva.subir.archivo"
        exact
      />
      <GuardianRoute
        path="/modulos/retenciones-masivas/tickets"
        component={RetencionesMasivasTickets}
        can="retencion.masiva.listar.tickets"
        exact
      />
      <Route
        path="/modulos/retenciones-masivas/tickets/:id/info"
        component={RetencionesMasivasTicketsInfo}
        exact
      />
    </Switch>
  );
};

export default RetencionesMasivasRoute;
